/**
 * Deeply clones an object, where subobjects are also cloned.
 */
export const clone = <T>(object?: T): T => JSON.parse(JSON.stringify(object));

export class Pipe<T> {
  private value: T;

  constructor(input: T) {
    this.value = input;
  }

  apply<OutputT>(callback: (input: T) => OutputT): Pipe<OutputT> {
    return new Pipe<OutputT>(callback(this.value));
  }

  output() {
    return this.value;
  }
}
